import React, { Component } from "react";
import config from 'react-global-configuration';
import jwt_decode from "jwt-decode";
import axios from "axios";
import { connect } from "react-redux";
import { BeatLoader } from "react-spinners";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import SingleCsvReportDownload from "../components/DownloadReport/SingleCsvReportDownload.jsx";
import LastRefresh from './LastRefresh.jsx';
import {
    PURPLE, DARK_ROW, DARK_ROW_LIGHT,
    GREEN_TXT, ORANGE_TXT, RED_TXT,
    HEADER_TH, SUB_HEADER_TH, DATA_TD, TEXT_TD, GROUP_TD,
    spinnerOverride as override, CheckIcon, CrossIcon
} from './reportConstants';

class PortfolioHeadPerformanceReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null,
            error: null,
            expandedPHs: {},
            expandedASEs: {},
            optionsBuilt: false,
            aseList: [], asoList: [], stateList: [], cityList: [],
            aseValue: [], asoValue: [], stateValue: [], cityValue: [],
        };
    }

    componentWillMount() {
        this.props.currentMenu("portfolio_head_performance_report");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({ user_id: decoded._id, object_type: decoded.object_type });
    }

    componentDidMount() {
        this.get_report();
    }

    activeFilters(extra) {
        return {
            ase: this.state.aseValue.map(o => o.value),
            aso: this.state.asoValue.map(o => o.value),
            state: this.state.stateValue.map(o => o.value),
            city: this.state.cityValue.map(o => o.value),
            ...extra,
        };
    }

    get_report() {
        this.setState({ loading: true, error: null });
        axios.post(
            config.get('API_URL') + '/InternalReport/ph-performance-report',
            this.activeFilters({ download: 0 }),
            { headers: { Authorization: localStorage.usertoken } }
        )
        .then(response => {
            const data = response.data && response.data.data ? response.data.data : null;
            this.setState(prevState => {
                const next = { data, loading: false, error: data ? null : "No data available" };
                if (data) {
                    const expandedPHs = {};
                    (data.portfolio_heads || []).forEach(ph => { expandedPHs[ph.portfolio_head_name] = true; });
                    next.expandedPHs = expandedPHs;
                    if (!prevState.optionsBuilt) {
                        Object.assign(next, this.buildFilterOptions(data), { optionsBuilt: true });
                    }
                }
                return next;
            });
        })
        .catch(error => {
            console.error("PH performance API error:", error);
            this.setState({ loading: false, error: "Failed to load data" });
        });
    }

    buildFilterOptions(data) {
        const aseSet = new Set(), asoSet = new Set(), stateSet = new Set(), citySet = new Set();
        (data.portfolio_heads || []).forEach(ph => {
            (ph.ases || []).forEach(ase => {
                if (ase.ase_name) aseSet.add(ase.ase_name);
                (ase.asos || []).forEach(aso => {
                    if (aso.aso_name) asoSet.add(aso.aso_name);
                    if (aso.state) stateSet.add(aso.state);
                    if (aso.city) citySet.add(aso.city);
                });
            });
        });
        const toOpts = set => [...set].sort().map(v => ({ value: v, label: v }));
        return {
            aseList: toOpts(aseSet),
            asoList: toOpts(asoSet),
            stateList: toOpts(stateSet),
            cityList: toOpts(citySet),
        };
    }

    changeAse   = (s) => this.setState({ aseValue:   s || [] });
    changeAso   = (s) => this.setState({ asoValue:   s || [] });
    changeState = (s) => this.setState({ stateValue: s || [] });
    changeCity  = (s) => this.setState({ cityValue:  s || [] });
    applyFilters = () => this.get_report();
    resetFilters = () => {
        this.setState({ aseValue: [], asoValue: [], stateValue: [], cityValue: [] }, () => this.get_report());
    }

    handleDownload = () => {
        if (!this.state.data) return;
        this.refs.csvDownload.downLoadReport(
            this.activeFilters({ download: 1 }),
            '/service_reports/portfolio-head-performance-report',
            'ph_performance',
            9999
        );
    }

    togglePH = (phName) => {
        this.setState(prev => ({
            expandedPHs: { ...prev.expandedPHs, [phName]: !prev.expandedPHs[phName] }
        }));
    }

    toggleASE = (phName, aseName) => {
        const key = `${phName}__${aseName}`;
        this.setState(prev => ({
            expandedASEs: { ...prev.expandedASEs, [key]: !prev.expandedASEs[key] }
        }));
    }

    apiColorStyle(hex) {
        if (!hex) return { backgroundColor: 'transparent', color: '#333' };
        const h = hex.toUpperCase();
        if (h === '#FFCCCC' || h === '#FFE2E2') return { backgroundColor: hex, color: RED_TXT };
        if (h === '#CCFFCC' || h === '#DCFCE7') return { backgroundColor: hex, color: GREEN_TXT };
        if (h === '#FFFFCC' || h === '#FFEBD5') return { backgroundColor: hex, color: ORANGE_TXT };
        return { backgroundColor: hex, color: '#333' };
    }

    isGreen(hex) {
        if (!hex) return null;
        const h = hex.toUpperCase();
        if (h === '#CCFFCC' || h === '#DCFCE7') return true;
        if (h === '#FFCCCC' || h === '#FFE2E2') return false;
        return null;
    }

    fmtPct(v)  { return (v === null || v === undefined || v === '') ? '-' : `${v}%`; }
    fmtDays(v) { return (v === null || v === undefined || v === '') ? '-' : v; }

    byLabel(arr) {
        const map = {};
        (arr || []).forEach(item => { map[item.label] = item; });
        return map;
    }

    renderMetricCells(arr, months, fmt, attendance) {
        const byLabel = this.byLabel(arr);
        return months.map(m => {
            const e = byLabel[m] || {};
            const green = attendance ? this.isGreen(e.color) : null;
            return (
                <td key={m} style={{ ...DATA_TD, ...this.apiColorStyle(e.color) }}>
                    {fmt(e.value)}
                    {attendance && green === true  ? <CheckIcon /> : null}
                    {attendance && green === false ? <CrossIcon /> : null}
                </td>
            );
        });
    }

    renderFilters() {
        return (
            <div className="content" style={{ backgroundColor: '#f5f5f5', padding: '15px 15px 15px 25px', marginBottom: '15px' }}>
                <div className="row">
                    <div className="col-md-2 filter-bottom5 padd-5">
                        <ReactMultiSelectCheckboxes name="ase" isMulti value={this.state.aseValue} options={this.state.aseList}
                            onChange={this.changeAse} placeholderButtonLabel="Select [ASE]" className="report-listbox" isClearable={true} />
                        <div className="clearfix"></div>
                    </div>
                    <div className="col-md-2 filter-bottom5 padd-5">
                        <ReactMultiSelectCheckboxes name="aso" isMulti value={this.state.asoValue} options={this.state.asoList}
                            onChange={this.changeAso} placeholderButtonLabel="Select [ASO]" className="report-listbox" isClearable={true} />
                        <div className="clearfix"></div>
                    </div>
                    <div className="col-md-2 filter-bottom5 padd-5">
                        <ReactMultiSelectCheckboxes name="state" isMulti value={this.state.stateValue} options={this.state.stateList}
                            onChange={this.changeState} placeholderButtonLabel="Select [State]" className="report-listbox" isClearable={true} />
                        <div className="clearfix"></div>
                    </div>
                    <div className="col-md-2 filter-bottom5 padd-5">
                        <ReactMultiSelectCheckboxes name="city" isMulti value={this.state.cityValue} options={this.state.cityList}
                            onChange={this.changeCity} placeholderButtonLabel="Select [City]" className="report-listbox" isClearable={true} />
                        <div className="clearfix"></div>
                    </div>
                    <div className="col-md-4 padd-5" style={{ paddingTop: '7px' }}>
                        <button type="button" className="primary apply-filter" role="button" onClick={this.applyFilters}>Apply</button>
                        &nbsp;
                        <button type="button" className="primary reset-filter" role="button" onClick={this.resetFilters}>Reset</button>
                    </div>
                </div>
            </div>
        );
    }

    shell(children) {
        const data = this.state.data;
        const title = (data && data.labels && data.labels.report_title) || 'Portfolio Head Performance Report';
        return (
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row"><div className="col-md-12"><div className="card">
                        <div className="col-md-9 no-padd">
                            <div className="header"><h4 className="title">{title}</h4><LastRefresh /></div>
                        </div>
                        <div className="col-md-3 pull-right">
                            <div className="r-p-menu">
                                <div className="report-header-icons">
                                    <div className="icon-button download-icon" title="Download Report"
                                        style={{ cursor: 'pointer' }} onClick={this.handleDownload}>
                                        <i className="fa fa-download"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="clearfix"></div>
                        {this.renderFilters()}
                        <div className="clearfix"></div>
                        {children}
                        <div className="footer"><div className="stats"><i></i></div></div>
                        <SingleCsvReportDownload ref="csvDownload" />
                    </div></div></div>
                </div>
            </div>
        );
    }

    render() {
        const { loading, error, data } = this.state;

        if (loading) return this.shell(
            <div className="content"><BeatLoader css={override} size={15} color={"#51bcda"} loading={loading} /></div>
        );
        if (error || !data) return this.shell(
            <div className="content"><div className="alert alert-danger">{error || "No data available"}</div></div>
        );

        const months   = data.months || [];
        const labels   = data.labels || {};
        const phList   = data.portfolio_heads || [];
        const totalCols = 3 + months.length * 2;


        return this.shell(
            <div className="content">
                <div className="content-tdetails-table table-responsive marginTop0" style={{ padding: 0 }}>
                    <table className="table" style={{ borderCollapse: 'separate', borderSpacing: 0, width: '100%', tableLayout: 'fixed' }}>
                        <colgroup>
                            <col style={{ width: '200px' }} />
                            <col style={{ width: '90px' }} />
                            <col style={{ width: '90px' }} />
                            {months.map((_, i) => <col key={`cg1-${i}`} style={{ width: '80px' }} />)}
                            {months.map((_, i) => <col key={`cg2-${i}`} style={{ width: '80px' }} />)}
                        </colgroup>
                        <thead>
                            <tr style={{ backgroundColor: PURPLE, color: 'white' }}>
                                <th rowSpan={2} style={HEADER_TH}>{labels.ph_col_header   || 'Employee Name'}</th>
                                <th rowSpan={2} style={HEADER_TH}>{labels.state_col_header || 'State'}</th>
                                <th rowSpan={2} style={HEADER_TH}>{labels.city_col_header  || 'City'}</th>
                                <th colSpan={months.length} style={HEADER_TH}>{labels.ph_okr1_header || '% of ASEs achieving performance target for the month'}</th>
                                <th colSpan={months.length} style={HEADER_TH}>{labels.ph_okr2_header || 'Open Tickets Outside TAT'}</th>
                            </tr>
                            <tr style={{ backgroundColor: '#fff' }}>
                                {months.map(m => <th key={`h1-${m}`} style={SUB_HEADER_TH}>{m}</th>)}
                                {months.map(m => <th key={`h2-${m}`} style={SUB_HEADER_TH}>{m}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {phList.length === 0 ? (
                                <tr><td colSpan={totalCols} style={{ textAlign: 'center', padding: '15px' }}>No data available</td></tr>
                            ) : phList.map((ph, phIdx) => {
                                const isPHExpanded = this.state.expandedPHs[ph.portfolio_head_name] === true;
                                const ases = ph.ases || [];
                                return (
                                    <React.Fragment key={phIdx}>

                                        {/* ── Portfolio Head group row ── */}
                                        <tr style={{ backgroundColor: DARK_ROW, cursor: 'pointer' }}
                                            onClick={() => this.togglePH(ph.portfolio_head_name)}>
                                            <td style={GROUP_TD} colSpan={3}>
                                                <span style={{ marginRight: '10px' }}>{isPHExpanded ? '▼' : '▶'}</span>
                                                {ph.portfolio_head_name} ({ph.total_ases != null ? ph.total_ases : ases.length} ASEs)
                                            </td>
                                            {this.renderMetricCells(ph.okr1_ase_performance_pct, months, this.fmtPct.bind(this), false)}
                                            {this.renderMetricCells(ph.okr2_open_outside_tat, months, this.fmtDays.bind(this), false)}
                                        </tr>

                                        {isPHExpanded && (
                                            <React.Fragment>
                                                {/* ── ASE section sub-header ── */}
                                                <tr style={{ backgroundColor: PURPLE, color: 'white' }}>
                                                    <th rowSpan={2} colSpan={3} style={HEADER_TH}>{labels.ase_col_header || 'ASE Name'}</th>
                                                    <th colSpan={months.length} style={HEADER_TH}>{labels.ase_okr1_header || '% of team members crossing performance target'}</th>
                                                    <th colSpan={months.length} style={HEADER_TH}>{labels.ase_okr2_header || '% of team members who meet the attendance target for the month'}</th>
                                                </tr>
                                                <tr style={{ backgroundColor: '#fff' }}>
                                                    {months.map(m => <th key={`ase1-${m}-${phIdx}`} style={SUB_HEADER_TH}>{m}</th>)}
                                                    {months.map(m => <th key={`ase2-${m}-${phIdx}`} style={SUB_HEADER_TH}>{m}</th>)}
                                                </tr>

                                                {ases.map((ase, aseIdx) => {
                                                    const aseKey      = `${ph.portfolio_head_name}__${ase.ase_name}`;
                                                    const isASEExpanded = this.state.expandedASEs[aseKey] === true;
                                                    const asos        = ase.asos || [];
                                                    return (
                                                        <React.Fragment key={aseIdx}>

                                                            {/* ── ASE row ── */}
                                                            <tr style={{ backgroundColor: DARK_ROW_LIGHT, cursor: 'pointer' }}
                                                                onClick={() => this.toggleASE(ph.portfolio_head_name, ase.ase_name)}>
                                                                <td style={{ ...GROUP_TD, paddingLeft: '28px' }} colSpan={3}>
                                                                    <span style={{ marginRight: '10px' }}>{isASEExpanded ? '▼' : '▶'}</span>
                                                                    {ase.ase_name} ({ase.total_asos != null ? ase.total_asos : asos.length} ASOs)
                                                                </td>
                                                                {this.renderMetricCells(ase.okr1_team_performance_pct, months, this.fmtPct.bind(this), false)}
                                                                {this.renderMetricCells(ase.okr2_team_attendance_pct, months, this.fmtPct.bind(this), false)}
                                                            </tr>

                                                            {isASEExpanded && (
                                                                <React.Fragment>
                                                                    {/* ── ASO section sub-header ── */}
                                                                    <tr style={{ backgroundColor: PURPLE, color: 'white' }}>
                                                                        <th rowSpan={2} style={HEADER_TH}>{labels.aso_col_header   || 'ASO Name'}</th>
                                                                        <th rowSpan={2} style={HEADER_TH}>{labels.state_col_header  || 'State'}</th>
                                                                        <th rowSpan={2} style={HEADER_TH}>{labels.city_col_header   || 'City'}</th>
                                                                        <th colSpan={months.length} style={HEADER_TH}>{labels.aso_okr1_header || 'Average of daily performance % for the month'}</th>
                                                                        <th colSpan={months.length} style={HEADER_TH}>{labels.aso_okr2_header || 'Minimum number of days marked present in the month'}</th>
                                                                    </tr>
                                                                    <tr style={{ backgroundColor: '#fff' }}>
                                                                        {months.map(m => <th key={`aso1-${m}-${aseKey}`} style={SUB_HEADER_TH}>{m}</th>)}
                                                                        {months.map(m => <th key={`aso2-${m}-${aseKey}`} style={SUB_HEADER_TH}>{m}</th>)}
                                                                    </tr>

                                                                    {/* ── ASO rows ── */}
                                                                    {asos.map((aso, aIdx) => (
                                                                        <tr key={aIdx} style={{ backgroundColor: '#fff' }}>
                                                                            <td style={{ ...TEXT_TD, paddingLeft: '42px' }}><strong>{aso.aso_name}</strong></td>
                                                                            <td style={TEXT_TD}>{aso.state || '-'}</td>
                                                                            <td style={TEXT_TD}>{aso.city  || '-'}</td>
                                                                            {this.renderMetricCells(aso.okr1_avg_performance, months, this.fmtPct.bind(this),  false)}
                                                                            {this.renderMetricCells(aso.okr2_days_present,    months, this.fmtDays.bind(this), true)}
                                                                        </tr>
                                                                    ))}
                                                                </React.Fragment>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    currentMenu: (name) => dispatch({ type: 'change_menu', payload: name })
});

export default connect(null, mapDispatchToProps)(PortfolioHeadPerformanceReport);
